import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import BillingSummaryFormattedMessages from '../../../messages/billing/BillingsSummaryFormattedMessages';

const BillingSummaryTable = ({ totals, list, handlePagination, pageCount }) => {
  return (
    <TableContainer sx={{ marginBottom: 4, overflowX: 'auto', width: '100%' }}>
      <Table>
        <TableHead>
          <TableRow
            sx={{
              whiteSpace: 'nowrap',
              '& .MuiTableCell-root': {
                borderBottom: 'none',
                paddingBottom: 0,
              },
              '& > .MuiTableCell-root:not(:first-of-type)': {
                textAlign: 'right',
              },
            }}
          >
            <TableCell>{BillingSummaryFormattedMessages.Date}</TableCell>
            <TableCell>{BillingSummaryFormattedMessages.invoiceNo}</TableCell>
            <TableCell>{BillingSummaryFormattedMessages.name}</TableCell>
            <TableCell>{BillingSummaryFormattedMessages.coo}</TableCell>
            <TableCell>{BillingSummaryFormattedMessages.paidDate}</TableCell>
            <TableCell>{BillingSummaryFormattedMessages.paymentType}</TableCell>
            <TableCell>{BillingSummaryFormattedMessages.suffix}</TableCell>
            <TableCell>{BillingSummaryFormattedMessages.setupFees}</TableCell>
            <TableCell>{BillingSummaryFormattedMessages.licenseFees}</TableCell>
            <TableCell>{BillingSummaryFormattedMessages.messages}</TableCell>
            <TableCell>{BillingSummaryFormattedMessages.replies}</TableCell>
            <TableCell>{BillingSummaryFormattedMessages.messageFees}</TableCell>
            <TableCell>{BillingSummaryFormattedMessages.totalFees}</TableCell>
            <TableCell>{BillingSummaryFormattedMessages.gst}</TableCell>
            <TableCell>{BillingSummaryFormattedMessages.CCsurcharge}</TableCell>
            <TableCell>{BillingSummaryFormattedMessages.total}</TableCell>
          </TableRow>
          <TableRow
            sx={{
              '& .MuiTableCell-root': {
                textAlign: 'right',
                paddingTop: 0,
              },
            }}
          >
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell>$</TableCell>
            <TableCell>$</TableCell>
            <TableCell>#</TableCell>
            <TableCell>#</TableCell>
            <TableCell>$</TableCell>
            <TableCell>$</TableCell>
            <TableCell>$</TableCell>
            <TableCell>$</TableCell>
            <TableCell>$</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {list}
          <TableRow
            sx={{
              '& .MuiTableCell-root': {
                backgroundColor: 'primary.light',
                fontWeight: 700,
                color: 'primary.main',
              },
              '& > .MuiTableCell-root:not(:first-of-type)': {
                textAlign: 'right',
              },
            }}
          >
            <TableCell colSpan={7}>
              {BillingSummaryFormattedMessages.total}
            </TableCell>
            <TableCell>{totals.SetupFeesDisplay}</TableCell>
            <TableCell>{totals.LicenceDisplay}</TableCell>
            <TableCell>{totals.Messages}</TableCell>
            <TableCell>{totals.Replies}</TableCell>
            <TableCell>{totals.MessageFeesDisplay}</TableCell>
            <TableCell>{totals.TotalFeesDisplay}</TableCell>
            <TableCell>{totals.GSTDisplay}</TableCell>
            <TableCell>{totals.CCSurchargeDisplay}</TableCell>
            <TableCell>{totals.TotalDisplay}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BillingSummaryTable;
